import { defineStore } from "pinia";
import PublicApi from "@/PublicApi.ts";

type MaintenanceConfig = {
  enabled: boolean;
  message?: string;
};

type StatusResponse = {
  maintenance?: MaintenanceConfig;
};

export const useMaintenanceStore = defineStore("maintenance", {
  state: () => ({
    enabled: false,
    message: "",
    loaded: false,
    loading: false,
  }),
  actions: {
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;

      try {
        const res = await PublicApi.get<StatusResponse>("/status/");

        this.enabled = !!res.data.maintenance?.enabled;
        this.message = res.data.maintenance?.message ?? "";
      } catch (err: unknown) {
        // Wenn Backend während Wartung mit 503 antwortet:
        const status =
          (err as any)?.response?.status as number | undefined;

        if (status === 503) {
          this.enabled = true;
          this.message = "Wartungsarbeiten – bitte später erneut versuchen.";
        } else {
          // wenn Status endpoint nicht erreichbar: eher "nicht wartung"
          this.enabled = false;
        }
      } finally {
        this.loaded = true;
        this.loading = false;
      }
    },

    setEnabled(enabled: boolean, message = "") {
      this.enabled = enabled;
      this.message = message;
      this.loaded = true;
    },
  },
});
